<p>
    <span class="body-medium">{{ showMore ? text : (text | slice: 0 : characterLimit) }}</span>
    @if (!showMore && textExceedLimit) {
        <span class="body-medium">...</span>
    }
</p>
@if (textExceedLimit) {
    <vc-button
        mode="text"
        [label]="showMore ? showLessLabel : showMoreLabel"
        (trigger)="showMore = !showMore; showMoreChange.emit(showMore)"></vc-button>
}
